<template>
    <component
      :is="`${sticker.type}Sticker`"
      v-bind="{ ...sticker, ...sticker.data }"
      :isPreventCover="isPreventCover"
      :isCover="isCover"
      :setCover="setCover"
      :setCbClick="setCbClick"
      :files="files"
      :pageSelected="pageSelected"
      @updateSticker="updateSticker"
      @deleteSticker="deleteSticker"
    />
  </template>
  
  <script>

    import surveySticker from './survey.vue';
    import sliderSticker from './slider.vue';
    import mentionSticker from './mention.vue';
    import localisationSticker from './localisation.vue';
    import hashtagSticker from './hashtag.vue';
    import linkSticker from './link.vue';
    import productSticker from './product.vue';
    import imageSticker from './image.vue';
    import gifSticker from './gif.vue';
    import musicSticker from './music.vue';
    import textSticker from './text.vue';
    import postSticker from './post.vue';

  export default {
    components: {
        surveySticker,
        sliderSticker,
        mentionSticker,
        localisationSticker,
        productSticker,
        imageSticker,
        gifSticker,
        hashtagSticker,
        linkSticker,
        musicSticker,
        textSticker,
        postSticker
        
    },
    props: {
      sticker: {
        type: Object,
        required: true
      },
      isPreventCover: {
        type: Boolean,
        required: false
      },
      isCover: {
        type: Boolean,
        required: false
      },
      setCover: Function,
      setCbClick: Function,
      files:Object,
      pageSelected: Object,
    },

    mounted () {
        if(this.sticker.isEditing && !this.isCover && !this.isPreventCover) {
            this.setCover(true)
        }
    },
 
    methods: {
      updateSticker(id,payload) {
        this.$emit('updateSticker', id, payload);
      },
      deleteSticker(id) {
        this.$emit('deleteSticker', id);
      }
    },
  };
  </script>
  